import React, { useState } from 'react';

import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import servicioObjetos from '../../../servicio/ServicioObjetos';
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../../../servicio/ServicioConstantes';

export const Formulario = (props) => {

    const { onFormularioOk } = props;
    let { growl } = props;
    const [fechaInicial, setFechaInicial] = useState(null);
    const [fechaFinal, setFechaFinal] = useState(null);
    const [render, setReder] = useState(true);

    const descargar = () => {
        if (servicioObjetos.esObjetoVacio(fechaInicial)) {
            growl.current.clear();
            growl.current.show({ severity: 'error', summary: 'Error', detail: 'Debes de elegir una fecha Inicial de Emisión', life: 10000 });
            return;
        }
        if (servicioObjetos.esObjetoVacio(fechaFinal)) {
            growl.current.clear();
            growl.current.show({ severity: 'error', summary: 'Error', detail: 'Debes de elegir una fecha Final de Emisión', life: 10000 });
            return;
        }
        let objetoRespuesta = { fechaInicial, fechaFinal }
        onFormularioOk(objetoRespuesta);
        setFechaInicial(null);
        setFechaFinal(null);
        setReder(false);
        setTimeout(() => {
            setReder(true);
          }, 100);
    }

    return (
        <div>
            {render ? <div className="card-w-title">
                <div className="p-grid">
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="fechaInicial">Fecha Inicial de Emisión:</label>
                    </div>
                    <div className="p-col-12 p-md-3">
                        <Calendar id="fechaInicial" appendTo={document.body} locale={CALENDARIO_ES_MX}
                            dateFormat={FORMATO_FECHA_CALENDAR} value={fechaInicial} onChange={(e) => setFechaInicial(e.value)} />
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="fechaFinal">Fecha Final de Emisión:</label>
                    </div>
                    <div className="p-col-12 p-md-3">
                        <Calendar id="fechaFinal" appendTo={document.body} locale={CALENDARIO_ES_MX}
                            dateFormat={FORMATO_FECHA_CALENDAR} value={fechaFinal} onChange={(e) => setFechaFinal(e.value)} />
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Button label="Solicitar" icon="pi-md-save" onClick={descargar} />
                    </div>
                </div>
            </div> : null}
        </div>
    );
}